/**
 * Сохраняет данные в localStorage в виде json
 * @param {string} key Ключ localstorage
 * @param data Сохраняемые данные
 */
export const setStorage = (key, data) => {
  localStorage.setItem(key, JSON.stringify(data))
}

/**
 * Получает данные из localStorage и парсит их из json
 * @param key
 * @return {any}
 */
export const getStorage = (key) => {
  const data = localStorage.getItem(key)
  try {
    return JSON.parse(data)
  } catch {
    return data
  }
}

export const removeStorage = key => {
  localStorage.removeItem(key)
}